var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5867 2.6665H10.4133C5.55999 2.6665 2.66666 5.55984 2.66666 10.4132V21.5732C2.66666 26.4398 5.55999 29.3332 10.4133 29.3332H21.5733C26.4267 29.3332 29.32 26.4398 29.32 21.5865V10.4132C29.3333 5.55984 26.44 2.6665 21.5867 2.6665ZM21 20.9998H11C10.4533 20.9998 9.99999 20.5465 9.99999 19.9998C9.99999 19.4532 10.4533 18.9998 11 18.9998H21C21.5467 18.9998 22 19.4532 22 19.9998C22 20.5465 21.5467 20.9998 21 20.9998ZM21 12.9998H11C10.4533 12.9998 9.99999 12.5465 9.99999 11.9998C9.99999 11.4532 10.4533 10.9998 11 10.9998H21C21.5467 10.9998 22 11.4532 22 11.9998C22 12.5465 21.5467 12.9998 21 12.9998Z",
    fill: "url(#paint0_linear_2057_23714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2057_23714",
    x1: 15.9933,
    y1: 2.6665,
    x2: 15.9933,
    y2: 29.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9201"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b995252593a097f44f90474ed2f720bb.svg";
export { ForwardRef as ReactComponent };